/* Printd Knock – temaskript: slider, karusell, mobilmeny, hover-video,
   produktgalleri, variantvelger og AJAX-handlekurv. Ingen avhengigheter. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero-slider */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (!track || track.children.length < 2) return;
    var active = 0;
    var count = track.children.length;

    function goTo(i) {
      active = (i + count) % count;
      track.style.transform = 'translateX(-' + active * 100 + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('bg-sf-ink', di === active);
        d.classList.toggle('bg-sf-ink/25', di !== active);
        d.setAttribute('aria-current', di === active ? 'true' : 'false');
      });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.dataset.heroDot, 10));
      });
    });
    goTo(0);
    if (!reducedMotion) {
      setInterval(function () { goTo(active + 1); }, 6000);
    }
  });

  /* Produktkarusell med piler */
  document.querySelectorAll('[data-carousel]').forEach(function (section) {
    var track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    function scroll(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { scroll(-1); });
    if (next) next.addEventListener('click', function () { scroll(1); });
  });

  /* Mobilmeny */
  var drawerToggle = document.querySelector('[data-drawer-toggle]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  if (drawerToggle && drawer) {
    drawerToggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('hidden') === false;
      drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawerToggle.querySelector('[data-icon-menu]').classList.toggle('hidden', open);
      drawerToggle.querySelector('[data-icon-close]').classList.toggle('hidden', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.classList.contains('hidden')) drawerToggle.click();
    });
  }

  /* Hover-video på produktkort */
  document.querySelectorAll('[data-hover-video]').forEach(function (card) {
    var video = card.querySelector('[data-card-video]');
    if (!video) return;
    card.addEventListener('pointerenter', function () {
      if (reducedMotion) return;
      video.classList.remove('opacity-0');
      video.classList.add('opacity-100');
      video.play().catch(function () {});
    });
    card.addEventListener('pointerleave', function () {
      video.classList.add('opacity-0');
      video.classList.remove('opacity-100');
      video.pause();
      video.currentTime = 0;
    });
  });

  /* Produktgalleri: sveipbar snap-karusell med thumbs (desktop) og prikker (mobil) */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var dots = root.querySelectorAll('[data-gallery-dot]');

    function markActive(idx) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('border-sf-ink', i === idx);
        t.classList.toggle('border-sf-ink/10', i !== idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('bg-sf-ink', i === idx);
        d.classList.toggle('bg-sf-ink/25', i !== idx);
      });
    }
    function goTo(idx) {
      if (!track) return;
      /* scrollTo med behavior:'smooth' henger på snap-mandatory-containere – bruk scrollIntoView */
      var slide = track.children[idx];
      if (slide) slide.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
      markActive(idx);
    }
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          markActive(Math.round(track.scrollLeft / track.clientWidth));
        }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Variantvelger: én select per valg – finn varianten som matcher kombinasjonen */
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var idInput = root.querySelector('[data-variant-id]');
    var stickyPrice = root.querySelector('[data-price-sticky]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    var dataEl = root.querySelector('[data-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    function setBuyState(available, label) {
      [addBtn, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = label;
      });
      if (stickyAdd) stickyAdd.textContent = available ? 'Legg i kurv' : label;
    }

    function onVariantChange() {
      var values = selects.map(function (s) { return s.value; });
      var variant = variants.find(function (v) {
        return v.options.length === values.length && v.options.every(function (o, i) { return o === values[i]; });
      });
      if (!variant) {
        setBuyState(false, 'Utilgjengelig');
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (compareEl) {
        compareEl.textContent = variant.compare || '';
        compareEl.classList.toggle('hidden', !variant.compare);
      }
      setBuyState(variant.available, variant.available ? 'Legg i handlekurv' : 'Utsolgt');
      if (variant.imageIdx !== null && variant.imageIdx !== undefined) goTo(variant.imageIdx);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', onVariantChange); });

    /* Sticky kjøpe-bar på mobil: vis når hovedknappen er ute av syne */
    var stickyBar = root.querySelector('[data-sticky-atc]');
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('translate-y-full', visible);
      }, { rootMargin: '-60px 0px 0px 0px' });
      io.observe(addBtn);
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var form = root.querySelector('form[action*="/cart/add"]');
        if (form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
      });
    }

    /* AJAX legg-i-handlekurv */
    var form = root.querySelector('form[action*="/cart/add"]');
    var feedback = root.querySelector('[data-cart-feedback]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add-to-cart failed');
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var count = document.querySelector('[data-cart-count]');
            if (count) {
              count.textContent = cart.item_count;
              count.classList.toggle('hidden', cart.item_count === 0);
            }
            if (feedback) feedback.classList.remove('hidden');
          })
          .catch(function () {
            form.submit(); // fall tilbake til vanlig innsending
          })
          .finally(function () {
            if (addBtn) addBtn.disabled = false;
          });
      });
    }
  });
})();
